<template>
  <b-card
    title="مدیریت سفارش ها"
  >
    <b-row>
      <b-col
        class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="2">
                <b-form-group
                  label="عنوان"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="وضعیت"
                  label-for="IsActive"
                >
                  <v-select
                    v-model="filterOptions.IsActive"
                    :options="enums('IsActive')"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
          :no-local-sorting="true"
          :sort-by="filterOptions.SortBy"
          :sort-desc="filterOptions.IsDesc"
          @sort-changed="sortChange"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="showModal(data.item)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Tour)="data">
            <b-link
              :to="{ name: 'tourdetails', params: { id: data.value.Id }}"
              style="color: #6e6b7b;"
            >
              {{ data.value.Title }}
              <br>
              <small class="text-muted">{{ data.value.Departure | date('jYYYY-jMM-jDD') }}</small>
            </b-link>
          </template>

          <template #cell(CreatedAt)="data">
            {{ data.value | date('jYYYY-jMM-jDD') }}
            <br>
            {{ data.value | date('HH:mm') }}
          </template>

          <template #cell(Status)="data">
            <b-badge
              :variant="enums('OrderStatus', 'value', data.value, 'badge')"
            >
              {{ enums('OrderStatus', 'value', data.value, 'text') }}
            </b-badge>
          </template>

          <template #cell(actions)="data">

            <div
              class="action-color"
            >
              <b-link @click="showModal(data.item)">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>

    <order-details
        v-if="isShow"
        v-model="isShow"
        :order="row"
        @save="save"
    />

  </b-card>
</template>

<script>

import OrderDetails from "@/views/menu/order/orderdetails.vue";

export default {
  name: 'Tour',
  components: {
    OrderDetails
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        SortBy: 'Id',
        IsDesc: true,
        CityId: null,
        IsActive: null,
      },
      isShow: false,
      row: {},
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Tour',
          label: 'تور',
        },
        {
          key: 'Name',
          label: 'نام و نام خانوادگی',
        },
        {
          key: 'Mobile',
          label: 'موبایل',
        },
        {
          key: 'CreatedAt',
          label: 'تاریخ',
        },
        // {
        //   key: 'Adult',
        //   label: 'بزرگسال',
        // },
        // {
        //   key: 'Child',
        //   label: 'کودک',
        // },
        // {
        //   key: 'Infant',
        //   label: 'نوزاد',
        // },
        // {
        //   key: 'Description',
        //   label: 'توضیحات',
        // },
        {
          key: 'Installment',
          label: 'قسطی',
        },
        {
          key: 'Status',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  computed: {
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.order.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    showModal(row) {
      this.row = JSON.parse(JSON.stringify(row))
      this.isShow = true
    },
    save(updatedRow) {
      const url = this.$api.order.update

      this.$http.post(url, updatedRow)
          .then(() => {
            this.update()
          }).catch(() => {
        this.isShow = true
      })
    },
  },
}
</script>

<style>
.col-width-89{
  width: 89px;
}

.action-color a{
  color: #6e6b7b !important;
}

</style>
